import React from "react";
import { NavLink } from "react-router-dom";

const MobileNavMenu = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const validateNavigation = (Id) => {
    props.SetLastTabClicked(Id);
    if (props.HasUnsavedChanges) {
      props.DisplayUnsavedChangesModal(true);
    } else {
      props.SetSelectedTab(Id);
      document.getElementById(Id).click();
      props.CloseMenu();
    }
  };
  return (
    <div className="mobile-menu-overlay is-mobile">
      <NavLink hidden to="/editProfile" id="edit-profile-nav-link"></NavLink>
      <div
        className="mobile-menu-outline"
        onClick={() => props.CloseMenu()}
      ></div>
      <div className="mobile-avatar-menu">
        <section
          className={
            props.SelectedTab === "pref-nav-item"
              ? "menu-item active-menu"
              : "menu-item"
          }
          onClick={() => validateNavigation("pref-nav-item")}
        >
          <i className="feather-sliders"></i>
          <p>{translateText("preferences_and_skills")}</p>
        </section>
        <section
          className={
            props.SelectedTab === "notif-nav-item"
              ? "menu-item active-menu"
              : "menu-item"
          }
          onClick={() => validateNavigation("notif-nav-item")}
        >
          <i className="feather-bell"></i>
          <p>{translateText("notifications")}</p>
        </section>
        <section
          className={
            props.SelectedTab === "account-nav-item"
              ? "menu-item active-menu"
              : "menu-item"
          }
          onClick={() => validateNavigation("account-nav-item")}
        >
          <i className="feather-user"></i>
          <p>{translateText("account_settings")}</p>
        </section>
      </div>
    </div>
  );
};

export default MobileNavMenu;
